import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { actions } from 'modules/user';
import { withRouter } from 'react-router-dom';

import { StepRouter, CancelModalFooter } from './components/layout';
import { useStepManager, useCancelFormState } from './hooks';
import { CancelModalProvider } from './context';
import { TOTAL_STEPS, MODAL_CONFIG } from './constants';
import { connect } from 'react-redux';

const WLCCancelModal = ({
  isOpen,
  toggle,
  user,
  pauseSubscription,
  downgradeSubscription,
  cancelSubscription,
  subscription,
  history
}) => {
  // Use custom hooks for state management
  const stepManager = useStepManager(TOTAL_STEPS);
  const formState = useCancelFormState();

  // Reset state when modal is closed
  const handleModalToggle = () => {
    if (isOpen) {
      // Reset to initial state when closing
      stepManager.reset();
      formState.resetForm();
    }
    toggle();
  };

  const navigateTo = useCallback(
    path => {
      history.push(path);
    },
    [history]
  );

  return (
    <Modal isOpen={isOpen} toggle={handleModalToggle} size={MODAL_CONFIG.size} className={MODAL_CONFIG.className}>
      <ModalHeader toggle={handleModalToggle}></ModalHeader>

      <CancelModalProvider
        stepManager={stepManager}
        formState={formState}
        onModalClose={handleModalToggle}
        user={user}
        subscription={subscription}
        pauseSubscription={pauseSubscription}
        downgradeSubscription={downgradeSubscription}
        cancelSubscription={cancelSubscription}
        navigateTo={navigateTo}
      >
        <ModalBody>
          <StepRouter />
        </ModalBody>

        <CancelModalFooter onKeepMembership={handleModalToggle} />
      </CancelModalProvider>
    </Modal>
  );
};

WLCCancelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  user: state.user
});
const mapDispatchToProps = {
  pauseSubscription: actions.pauseSubscription,
  downgradeSubscription: actions.downgradeSubscription,
  cancelSubscription: actions.cancelSubscription
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WLCCancelModal));
